import { createAsyncThunk } from "@reduxjs/toolkit";
import SuppliersApiService from "../../infrastructure/api/suppliers";
import { setMessage } from "../slices/message";

// Get Active Suppliers
export const fetchActiveSuppliers = createAsyncThunk(
  "suppliers/fetchActive",
  async (params, { dispatch, rejectWithValue }) => {
    try {
      const response = await SuppliersApiService.getActiveSuppliers(params);
      return response;
    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.message ||
        "خطا در دریافت لیست تأمین‌کنندگان";
      dispatch(setMessage(message));
      return rejectWithValue(message);
    }
  }
);

// Get Supplier Details
export const fetchSupplierDetails = createAsyncThunk(
  "suppliers/fetchDetails",
  async (supplierId, { dispatch, rejectWithValue }) => {
    try {
      const response = await SuppliersApiService.getSupplierDetails(supplierId);
      return response;
    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.message ||
        "خطا در دریافت جزئیات تأمین‌کننده";
      dispatch(setMessage(message));
      return rejectWithValue(message);
    }
  }
);

// Search Suppliers
export const searchSuppliers = createAsyncThunk(
  "suppliers/search",
  async (searchParams, { dispatch, rejectWithValue }) => {
    try {
      const response = await SuppliersApiService.searchSuppliers(searchParams);
      return response;
    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.message ||
        "خطا در جستجوی تأمین‌کنندگان";
      dispatch(setMessage(message));
      return rejectWithValue(message);
    }
  }
);

// Get Supplier Products
export const fetchSupplierProducts = createAsyncThunk(
  "suppliers/fetchProducts",
  async ({ supplierId, params }, { dispatch, rejectWithValue }) => {
    try {
      const response = await SuppliersApiService.getSupplierProducts(
        supplierId,
        params
      );
      return response;
    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.message ||
        "خطا در دریافت محصولات تأمین‌کننده";
      dispatch(setMessage(message));
      return rejectWithValue(message);
    }
  }
);

// Search Products
export const searchProducts = createAsyncThunk(
  "suppliers/searchProducts",
  async (searchParams, { dispatch, rejectWithValue }) => {
    try {
      const response = await SuppliersApiService.searchProducts(searchParams);
      return response;
    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.message ||
        "خطا در جستجوی محصولات";
      dispatch(setMessage(message));
      return rejectWithValue(message);
    }
  }
);
